module.exports = __webpack_public_path__ + "img/pdf-import.10a0e6b9.svg";